<template>
  <div>    
    <base-input :label="titulo ? titulo : campo.titulo" class="mb-0">
      <v-select id="input-especialidade" class="select-especialidade" 
        :value="value"
        @input="onChange"
       :options="listaEspecialidade" :disabled="leitura"      
        :reduce="especialidade => especialidade.id" label="descricao" placeholder="Informe a especialidade">
        <template #no-options>
          Nenhuma especialidade encontrada
        </template>
      </v-select>
    </base-input>
  </div>
</template>
  
<script>
import appUtils from '@/composables/utils';
import AgendaService from '../../service/AgendaService';

export default {
  props: {
    leitura: false,
    campo: Object,
    titulo: null,
    value: null
  },
  components: {
    
  },
  data() {
    return {
      show: false,
      showFrom: "",
      filaShow: [],
      id: null,     
      listaEspecialidade: [],      
    }
  },
  computed: {

  },
  mounted() {
    this.inicializar()
  },
  methods: {
    inicializar() {      
      this.buscarEspecialidades()      
    },
    buscarEspecialidades() {

      const { ativarShow, desativarShow } = appUtils(this)

      ativarShow("buscarEspecialidades");

      let dadosUsuario = JSON.parse(localStorage.getItem('dadosUsuario'))

      let dadosConsulta = {
        
      }

      AgendaService.listaEspecialidade(dadosConsulta)
        .then(resposta => {
          this.listaEspecialidade = resposta.data.obj          
          desativarShow("buscarEspecialidades");
        }).catch(error => {
          desativarShow("buscarEspecialidades");
        })
    },    
    onChange(novaEspecialidade) {
      this.$emit('input', novaEspecialidade)  // Comunicação com o pai via v-model
    }    
  },
  computed: {
    
  }
}

</script>
<style>


</style>